export default function genererSignataire() {
  return {
    contactPrincipal: null,
    signataireRelance: null,
    fonctionSignataireRelance: null,
    signataireBaux: null,
    fonctionSignataireBaux: null,
  };
}
